exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gray-btn[data-v-a1bd2838] {\n  background-color: #ebebe9;\n  color: #1a89e5;\n  font-weight: bold;\n  outline: none;\n}\n", ""]);

// exports
